import remarkGfm from 'remark-gfm';
import {
  primaryDarkest,
  primaryLightest,
  purpleDarkest,
  purpleLightest,
  redDarkest,
  redLightest,
} from '../../../../styles/design-tokens';
import type { ComponentPropsWithoutRef } from 'react';
import type { PrStateStyle } from './pr-comment-panel.type';

/** Remark plugins for comment bodies: GitHub-flavoured Markdown (tables, task lists, strikethrough). */
const REMARK_PLUGINS = [remarkGfm];

/** Spacing around the divider between the PR header and the comment section. */
const DIVIDER_MARGIN = { margin: '14px 0' } as const;

/** Badge colours per PR state, keyed by the lower-cased state; unknown states fall back to neutral. */
const PR_STATE_STYLES: Record<string, PrStateStyle> = {
  open: { color: primaryDarkest, background: primaryLightest },
  merged: { color: purpleDarkest, background: purpleLightest },
  closed: { color: redDarkest, background: redLightest },
};

/**
 * Markdown element overrides for comment bodies. Links open in a new tab
 * without leaking the opener; images are shown as links rather than loaded,
 * since GitHub attachment URLs need auth and remote images would otherwise
 * fetch third-party content from inside the app.
 */
const MARKDOWN_COMPONENTS = {
  a: ({ node: _node, ...props }: ComponentPropsWithoutRef<'a'> & { node?: unknown }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
  img: ({ src, alt }: ComponentPropsWithoutRef<'img'> & { node?: unknown }) => (
    <a href={typeof src === 'string' ? src : undefined} target="_blank" rel="noopener noreferrer">
      {alt || 'image'}
    </a>
  ),
};

export { DIVIDER_MARGIN, MARKDOWN_COMPONENTS, PR_STATE_STYLES, REMARK_PLUGINS };
